import React, { FC } from 'react';
import { graphql } from 'gatsby';
import classNames from 'classnames';

import { DangerouslySetInnerHtml } from 'layout';

import { IDElementProps } from './models';
import './DElement.scss';

const DElement: FC<IDElementProps> = ({ data, sizeType, colorType }) => {
  const { title, text } = data?.properties;

  return (
    <div
      data-testid="DElement"
      className={classNames('d-element', {
        [`d-element__size-type-${sizeType}`]: sizeType,
        [`d-element__color-type-${colorType}`]: colorType,
      })}
    >
      <strong>{title}</strong>
      <DangerouslySetInnerHtml className="d-element__text" html={text} />
    </div>
  );
};

export const query = graphql`
  fragment FragmentDElement on TDElement {
    properties {
      title
      text
    }
  }
`;

export default DElement;
